import React from "react";
import styled from "styled-components";
//
import { RichText } from "components/prismic";
//
export default ({ long_title, pictogram, text, title, ...rest }) => (
  <Wrap>
    <Picrogam>
      <img src={pictogram.url} alt={title} />
    </Picrogam>
    <Item>
      <Title>{long_title}</Title>
      {text && (
        <Text>
          <RichText {...text} />
        </Text>
      )}
    </Item>
  </Wrap>
);
//
const Wrap = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
  margin: 0 auto;
  max-width: 1350px;
  min-height: 100vh;
  min-height: calc(100vh - 136px - 320px);
  padding: 2rem 1rem;
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    padding: 4rem 3rem;
  }
`;
const Title = styled.h2`
  margin: 0.5rem 0;
`;
const Item = styled.div``;
const Text = styled.div`
  border-top: solid 1px #6a7fbd;

  @media (min-width: 768px) {
    padding-right: 5rem;
  }
`;

const Picrogam = styled.div`
  display: grid;
  height: auto;
  position: relative;
  max-width: 100%;

  img {
    max-height: 50vh;
    justify-self: center;

    @media (min-width: 768px) {
      max-height: 70vh;
      justify-self: end;
    }

    @media (min-width: 992px) {
      padding: 0 3vw;
    }
  }
`;
